import React from "react";
import { Modal, ModalBody } from "reactstrap";
import imgSuccess from "assets/images/success.png";

const CheckAvailabilityModal = ({ modal, setModal }) => {
	return (
		<Modal isOpen={modal} toggle={setModal} className="websitPages br-25">
			<ModalBody>
				<div className="overflow-hidden">
					<h5 className="fw-bold font-size-18 fw-bold text-primary">
						{" "}
						The Request has been sent successfully
					</h5>
					<div className="text-center">
						<img src={imgSuccess} className="img-fluid mt-3" />
						<p className="font-size-14 text-primary pt-4 pb-3">
							One of our agents will verify that the unit is available or not,
							then you will be notified of the result via email
						</p>
						<button className="btn btn-primary w-100 " onClick={setModal}>
							Done
						</button>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default CheckAvailabilityModal;
